<template>
    <div class="row" v-if="!isTreatmentPlanLoading">

        <div class="col-12">
            <!-- Card -->
            <div class="card" data-toggle="lists" v-if="plans.length">
                <div class="card-header">
                    <div class="row align-items-center">
                        <div class="col"></div>
                        <!-- <div class="col-auto">
                            <button class="btn btn-white" @click="elementaryModal">{{$t('Initial examination')}}</button>
                        </div> -->
                        <div class="col-auto">
                            <button
                                class="btn btn-primary my-auto mr-2"
                                @click="createBlankPlan()"
                            >{{ $t('Add treatment plan') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="col-12" v-if="plans.length">
            <div v-for="(plan, planIndex) in plans"
                :key="planIndex"
                @click="selectedPlan = planIndex"
            >
                <plan
                    :plan="plan"
                    :edit-mode.sync="editMode"
                    :customer-id="customerId"
                    :expanded="selectedPlan === planIndex"/>
            </div>
        </div>
        <div class="col-12" v-else>
            <div class="card card-inactive">
                <div class="card-body text-center text-muted small">
                    <div class="row justify-content-center">
                        <div class="col-12 mt-5">
                            <div class="d-flex justify-content-center">
                                <img
                                    src="@/assets/img/illustrations/32desk/treatment-plan.svg"
                                    class="img-fluid mt-n5 mb-5"
                                    style="max-height: 400px;"
                                />
                            </div>
                            <p class="text-muted mb-4">{{ $t('Nothing yet') }}</p>
                        </div>
                        <div class="col-12">
                            <button
                                class="btn btn-primary my-auto mr-2"
                                @click="createBlankPlan()"
                            >{{ $t('Add treatment plan') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <print-plan id="PrintPlanModal"></print-plan>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import { modalMixins } from "@/mixins/modal.js";
import CustomSwitch from "@/components/CustomSwitch.vue";
import Plan from "./Plan.vue";
import PrintPlan from "./PrintPlan.vue";

export default {
    name: "TreatmentPlan",
    props: {
        map: Array,
        customerId: String,
    },
    mixins: [modalMixins],
    components: {
        Plan,
        CustomSwitch,
        PrintPlan
    },
    data() {
        return {
            selectedPlan: 0,
            editMode: false
        };
    },
    created() {
        this.find({ query: { customerId: this.customerId } });
    },
    computed: {
        ...mapGetters('customers', ['get']),
        ...mapGetters("treatment-plan", { findPlansInStore: "find" }),
        ...mapState('treatment-plan', { isTreatmentPlanLoading: 'isFindPending' }),

        plans() {
            return this.findPlansInStore({
                query: {
                    customerId: this.customerId,
                    $sort: {
                        createdAt: -1
                    }
                }
            }).data;
        },
        customer() {
            return this.get(this.customerId);
        },
    },
    methods: {
        ...mapActions("treatment-plan", ["find", "patch", "remove", "create"]),
        ...mapActions("cart", { createCart: "create" }),

        createBlankPlan() {
            let plan = {};
            plan.customerId = this.customerId;
            this.editMode = true;
            this.create(plan).then(() => {
                this.selectedPlan = 0;
                this.openModal({id: 'AddTreatmentModal-'+this.selectedPlan, model: {}});
            })
        },

        currentPlan() {
            return this.$copy(this.plans[this.selectedPlan])
        },

        savePlan(plan) {
            return this.patch([plan._id, plan]);
        }
    }
};
</script>

<style scoped>
.card-body .list-group-item .row.align-items-center.text-center {
    display: flex;
    flex-direction: column;
}

.card-body .list-group-item .btn.btn-white.mt-4 {
    white-space: nowrap;
}

.card-body .list-group .item svg {
    width: 34px;
    height: 34px;
}

.card-body .list-group .tooth-items {
    margin: 0;
    margin-top: 12px;
}

.card-body .list-group .tooth-items .row {
    margin: 0;
}

.no-margin-wrapper {
    margin: 0;
}

.no-margin-wrapper .column .col-1.text-center {
    padding-left: 0;
}

.card-body .list-group .steps-wrapper .pointer .card {
    margin-bottom: 0;
}

.card-body .list-group .steps-wrapper {
    border-radius: 0 0.5rem 0.5rem 0;
    border: 1px solid #edf2f9;
}

.card-body .list-group .steps-wrapper .pointer .card {
    border-radius: 0;
    box-shadow: none;
    border: none;
    border-bottom: 1px solid rgba(228, 236, 246, 0.3);
}

.card-body .list-group .steps-wrapper .pointer:last-child .card {
    border: none;
}

</style>
